import { IMAGES } from "./images";

export const SERVICES = [
  {
    id: "scholarship",
    title: "Scholarship Assistance",
    shortDescription:
      "Discover and apply for scholarships that can cover up to 100% of your tuition fees abroad.",
    description:
      "We help deserving students identify scholarship opportunities across the USA, Canada, UK, Australia, and Europe. Our team guides you through eligibility checks, essay writing, and application submissions to maximize your chances of funding.",
    route: "/scholarship",
    image: IMAGES.scholarship,
    icon: "🎓",
  },
  {
    id: "resume",
    title: "SOP & Resume Writing",
    shortDescription:
      "Stand out with professionally written Statements of Purpose, CVs, and recommendation letters.",
    description:
      "Our expert writers craft compelling SOPs, resumes, and LORs tailored to your target universities. We highlight your strengths, align with program requirements, and ensure your application documents make a lasting impression.",
    route: "/resume",
    image: IMAGES.resumeWriting,
    icon: "📝",
  },
  {
    id: "accommodation",
    title: "Student Accommodation",
    shortDescription:
      "Find safe, affordable housing near your university before you even land.",
    description:
      "Browse verified student accommodations with transparent pricing. We handle booking, lease agreements, and coordinate with landlords so you have a home ready on arrival day.",
    route: "/accomodation",
    image: IMAGES.studentAccommodation,
    icon: "🏠",
  },
  {
    id: "sim",
    title: "International SIM Cards",
    shortDescription:
      "Stay connected from day one with pre-activated international SIM cards.",
    description:
      "Get affordable data and calling plans for your destination country. We deliver SIM cards to your Indian address before departure so you're connected the moment you land.",
    route: "/sim",
    image: IMAGES.internationalSimCard,
    icon: "📱",
  },
  {
    id: "visa",
    title: "Student Visa Assistance",
    shortDescription:
      "Navigate complex visa processes with expert guidance and high approval rates.",
    description:
      "From document preparation to mock interviews, our visa specialists ensure your application is complete, accurate, and compelling. We've helped thousands of students secure visas for top destinations.",
    route: "/visa",
    image: IMAGES.visaAssistance,
    icon: "✈️",
  },
  {
    id: "air",
    title: "Air Ticket Booking",
    shortDescription:
      "Best student fares to the USA, Canada, UK, Australia, and beyond.",
    description:
      "Access exclusive student discounts on international flights. We compare airlines, handle bookings, and provide 24/7 travel support before, during, and after your journey.",
    route: "/air",
    image: IMAGES.airTickets,
    icon: "🛫",
  },
];

export const HOME_SERVICES = [
  {
    title: "University Admissions",
    description:
      "Get personalized university shortlisting, application filing, and admission follow-ups for top institutions worldwide.",
    image: IMAGES.scholarship,
    route: "/services",
  },
  {
    title: "Visa & Immigration",
    description:
      "Expert visa filing with document verification, financial proof guidance, and mock interview sessions.",
    image: IMAGES.visaAssistance,
    route: "/visa",
  },
  {
    title: "Scholarship Programs",
    description:
      "Access exclusive scholarships and financial aid opportunities to reduce your study-abroad costs significantly.",
    image: IMAGES.scholarship,
    route: "/scholarship",
  },
];
